import { render, staticRenderFns } from "./BaseChipSelected.vue?vue&type=template&id=1af28fd0&"
import script from "./BaseChipSelected.vue?vue&type=script&lang=js&"
export * from "./BaseChipSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports